var _circle, _circle2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymousFeedbackAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D8D8D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.5,
    r: 3.5,
    fill: "#ACB0B0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4610_17489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 13,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33186 13.125C5.35704 14.1071 4 16.1454 4 18.5006C4 21.8143 6.68629 24.5006 10 24.5006C13.3137 24.5006 16 21.8143 16 18.5006C16 16.1454 14.643 14.1071 12.6681 13.125C11.9216 13.6756 10.9988 14.001 10 14.001C9.00121 14.001 8.07842 13.6756 7.33186 13.125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4610_17489)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ACB0B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymousFeedbackAvatar);
export default __webpack_public_path__ + "static/media/anonymous-feedback-avatar.3ccf6518d8da3dbccfab6ee769d4f52a.svg";
export { ForwardRef as ReactComponent };